import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout2',
  templateUrl: './layout2.component.html',
  styleUrls: ['./layout2.component.scss']
})
export class Layout2Component implements OnInit {
  @Input() colorPrimary: string;
  @Input() colorSecondary: string;

  constructor() { }

  ngOnInit() {
  }

}
